import { render, staticRenderFns } from "./accountTem.vue?vue&type=template&id=18011331&scoped=true"
import script from "./accountTem.vue?vue&type=script&lang=js"
export * from "./accountTem.vue?vue&type=script&lang=js"
import style0 from "./accountTem.vue?vue&type=style&index=0&id=18011331&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18011331",
  null
  
)

export default component.exports